export default "__VITE_ASSET__GN7To6OM__"